import moment from 'moment'
import Bluebird from 'bluebird'
// import Logger from './logger'
import api from './api'
import config from './config'

// const logger = Logger.child({ component: 'DemoController' })

const playOnceUrl = process.env.PLAY_ONCE_VIDEO_URL ?? 'https://res.cloudinary.com/kitchenmate/video/upload/v1746573003/NAMA%202025/ii5pwsawdhdjapubza3z.mp4'

export const videoWidth = 1920

interface Promo {
	voucherId: number
	videoUrl: string
}

export const promos: Record<string, Promo> = {
	frozen: {
		voucherId: null,
		videoUrl: process.env.FROZEN_PROMO_VIDEO_URL ?? 'https://res.cloudinary.com/kitchenmate/video/upload/v1776875999/Gen4/BOGO_-_Ice_Cream.mp4',
	},
	drink: {
		voucherId: null,
		videoUrl: process.env.DRINK_PROMO_VIDEO_URL ?? 'https://res.cloudinary.com/kitchenmate/video/upload/v1746573003/NAMA%202025/cizzmentjpviegjhzvph.mp4',
	},
	// salad: {
	// 	voucherId: 30911,
	// 	videoUrl: process.env.SALAD_PROMO_VIDEO_URL ?? 'https://res.cloudinary.com/kitchenmate/video/upload/v1715049328/Gen4/amumkmeijyng5ntyecxj.mp4',
	// },
	// meal: {
	// 	voucherId: 30910,
	// 	videoUrl: process.env.MEAL_PROMO_VIDEO_URL ?? 'https://res.cloudinary.com/kitchenmate/video/upload/v1715049286/Gen4/sdng9ajn2w4xahm1hjs3.mp4',
	// },
}

export const getCroppedVideo = (url, duration = null, x = 0) => {
	return url.replace('/upload', `/upload/w_1920,h_540,c_crop,x_${x},y_0` + (duration ? `,du_${duration}` : ''))
}

const getConfigToPlayVideoAcrossScreens = (videoUrl, duration = null) => {
	return {
		Left: {
			id: 2873,
			playOnceUrl: getCroppedVideo(videoUrl, duration),
		},
		Middle: {
			id: 2884,
			playOnceUrl: getCroppedVideo(videoUrl, duration, videoWidth),
		},
		Right: {
			id: 2883,
			playOnceUrl: getCroppedVideo(videoUrl, duration, videoWidth * 2),
		},
	}
}

const showVideoAcrossTopDisplays = async (videoUrl) => {
	const cabinetConfig = getConfigToPlayVideoAcrossScreens(videoUrl)
	const playOnce = true
	const playAt = moment().add(1.5, 'seconds').toDate()
	await Bluebird.map(Object.values(cabinetConfig), async (cabinet) => {
		return api.updateTopDisplay(cabinet.id, cabinet.playOnceUrl, playOnce, playAt)
	})
}

export const updateTopDisplays = async () => {
	await api.validateCanUpdateBooth()
	await api.lockBoothToUpdates()
	await showVideoAcrossTopDisplays(playOnceUrl)

	// Add artificial delay to give enough chance to see instructions to look up
	await Bluebird.delay(moment.duration(5, 'seconds').asMilliseconds())
}

export const applyPromo = async (promo) => {
	await api.validateCanUpdateBooth()
	await api.lockBoothToUpdates()

	await Bluebird.all([
		showVideoAcrossTopDisplays(promo.videoUrl),
		promo.voucherId != null && api.activatePromo(promo.voucherId),
	])

	// Add artificial delay to give enough chance to see instructions to look up
	await Bluebird.delay(moment.duration(2, 'seconds').asMilliseconds())

	// Then deactivate the promo after 1 minute
	// TODO: make sure it doesn't get activate again in the meantime
	setTimeout(async () => {
		try {
			promo.voucherId != null && await api.deactivatePromo(promo.voucherId)
		} catch (err) {
			// logger.error(err, 'Could not deactivate promo', { voucherId: promo.voucherId })
		}
	}, 60 * 1000)

}
